export function sortFilesByDateUploaded<T extends { createdAt: string | Date }>(
  files: readonly T[],
): T[] {
  return [...files].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  );
}

export function getRecentUploads<T extends { createdAt: string | Date }>(
  files: readonly T[],
  limit = 3,
): T[] {
  return sortFilesByDateUploaded(files).slice(0, limit);
}
